import React from 'react';
import './MobileTimesCompNew.scss';

const MobileTimesCompShimUI = () => {
  const shimmerDays = Array.from({ length: 30 }, (_, index) => index + 1);

  return (
    <div className="timeslot-container shimmer">
      <div className="month-nav">
        <div className="arrow-container left disabled">
          <div className="shimmer-box arrow" />
        </div>
        <span className="shimmer-box month-label" />
        <div className="arrow-container right disabled">
          <div className="shimmer-box arrow" />
        </div>
      </div>
      <div className="day-scroll">
        {shimmerDays.map((day) => (
          <div key={day} className="day-box-shimmer no-slots">
          </div>
        ))}
      </div>
      <div className="slots-list">
        <div className="timeslot-grid">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="timeslot-shimmer" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MobileTimesCompShimUI;